import { useState } from 'react';
import { Badge, Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag, faUser } from '@fortawesome/pro-regular-svg-icons';

const MAX_VISIBLE_TAGS = 3;

interface Props {
  tags: string[];
  maxWidth?: string;
}

const ReviewerTagBadges = ({ tags }: Props) => {
  const [showAllTags, setShowAllTags] = useState(false);

  if (!tags.length) {
    return null;
  }

  const visibleTags = showAllTags ? tags : tags.slice(0, MAX_VISIBLE_TAGS);

  return (
    <Flex textStyle="textContext" gap={2} my={1} flexWrap="wrap">
      {visibleTags.length >= 1 && (
        <Flex textStyle="textContext" alignItems={'flex-start'}>
          {' '}
          <Box>
            <FontAwesomeIcon icon={faTag} size="lg" />
          </Box>
          <Text textStyle="textContext">Tags: </Text>
        </Flex>
      )}

      {visibleTags.map(tag => (
        <Tooltip key={tag} label={tag} hasArrow placement="top">
          <Box width="fit-content">
            <Badge variant="neutral" size="context">
              <Flex gap={1} alignItems="center">
                <FontAwesomeIcon icon={faUser} size="sm" />
                <Text textStyle="textContext" noOfLines={1} maxW="250px">
                  {tag}
                </Text>
              </Flex>
            </Badge>
          </Box>
        </Tooltip>
      ))}

      {tags.length > MAX_VISIBLE_TAGS && (
        <Box>
          <Badge
            variant="outline"
            size="context"
            cursor="pointer"
            onClick={() => setShowAllTags(prev => !prev)}
          >
            <Text paddingLeft={1} textStyle="textContext">
              {showAllTags
                ? 'Show Less'
                : `+${tags.length - MAX_VISIBLE_TAGS} more`}
            </Text>
          </Badge>
        </Box>
      )}
    </Flex>
  );
};

export default ReviewerTagBadges;
